import script from "./Main2.vue?vue&type=script&setup=true&lang=js"
export * from "./Main2.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__